<template>
  <div
    class="msg-pure-text"
    :class="{
      disabled: isDisabled,
      'select-none': selectNone
    }"
  >
    <div class="msg-c2b-ref" @click="handleRefMsgClick" v-if="isReplayMsg">
      <div class="msg-c2b-ref-meta">
        <div class="msg-c2b-ref-name">{{ formatNickname }}:</div>
        <div class="msg-c2b-ref-time">{{ formatTime }}</div>
      </div>
      <div class="msg-c2b-ref-content">{{ sourceMsg.bytes_summary }}</div>
    </div>
    <span ref="msgTxt" v-html="processedText"></span>
    <msg-text-translate :data="data.content" v-if="isTransLate()"></msg-text-translate>
  </div>
</template>

<script>
import Utils from '@/utils/string';
import bindlLinkClick, { parseQdwebURL } from '@/utils/bindlLinkClick';
import MsgTextTranslate from '../MsgTextTranslate';
import dayjs from 'dayjs';
import globalWin from '@/utils/globalWin';

export default {
  props: {
    selectNone: {
      type: Boolean,
      default: false,
    },
    data: Object,
  },
  components: {
    MsgTextTranslate,
  },
  data() {
    return {
      isDisabled: false,
    };
  },
  computed: {
    formatTime() {
      const second = this.sourceMsg.uint64_time;
      return dayjs(second).format('HH:mm');
    },
    formatNickname() {
      const dir = this.sourceMsg.uint32_msg_direction;
      if (dir === 1 || dir === '访客') {
        return '我';
      }
      return '客服';
    },
    sourceMsg() {
      /* eslint-disable max-len */
      return this.data.$_sourceMsg || this.data?.msgHead?.msg_third_app_info?.bytes_third_app_buf?.bytes_crm_buf?.qd_source_msg;
    },
    hasMsgId() {
      return this.data?.$_sourceMsg?.str_current_qidian_msg_unique_id || this.data?.msgHead?.msg_third_app_info?.bytes_third_app_buf?.bytes_crm_buf?.str_current_qidian_msg_unique_id;
    },
    isReplayMsg() {
      console.log(354364656546, this.data);
      /* eslint-disable max-len */
      return this.data.$_sourceMsg || this.data?.msgHead?.msg_third_app_info?.bytes_third_app_buf?.bytes_crm_buf?.qd_source_msg?.str_reference_qidian_msg_unique_id;
    },
    processedText() {
      // 是否是可信任的安全html字符串，如果是则不需要转码处理，直接显示即可。
      const isSafeHtml = this.data?.crm?.msg_webim_extra_data?.bool_is_safe_html_text;
      let text = this.data.content;
      if (!isSafeHtml) {
        // 如果不是安全html
        // 过滤html，仅保留 a ；
        text = Utils.filterHTML(text);
      }
      text = Utils.emojiEscape(text);
      // 当文本中不包括 a连接时，才进行转义
      if (text.indexOf('<a ') === -1) {
        text = Utils.urlEscape(text);
      }
      return Utils.coverEmojIndex2EmojiImg(text);
    },
  },
  mounted() {
    this.initDelegations();
  },
  methods: {
    handleRefMsgClick() {
      this.$emit('onReplayMsgClick', this.sourceMsg.str_reference_qidian_msg_unique_id);
    },
    linkClickHandler(link) {
      const href = link.getAttribute('href');
      const parsedHref = parseQdwebURL(href);
      if (parsedHref && parsedHref.method === 'leaveform') {
        // disabled link
        this.isDisabled = true;
      }
      // this.disabled = true;
    },
    // 处理<a>的点击
    initDelegations() {
      bindlLinkClick(this.$refs.msgTxt, 'a', {
        callback: this.linkClickHandler,
      });
    },
    isTransLate() {
      // const { translateSwitch, translateAuto, isTranslate } = globalWin.translate;
      const { translateSwitch, translateAuto  } = globalWin.translate || {};
      // return +translateSwitch && (+translateAuto || +isTranslate) && !this.data.mine;
      return +translateSwitch && translateAuto && !this.data.mine;
    },
  },
};
</script>

<style lang="less" scoped>
// 文本消息样式
.msg-pure-text {
  font-family: @emoji-family, "PingFangSC-Regular", "Microsoft YaHei",
    "sans-serif";
  box-sizing: border-box;
  font-size: 14px;
  line-height: 20px;
  word-break: break-word;
  word-wrap: break-word;
  white-space: pre-wrap;
  padding: 10px 15px;
  max-width: 300px;
  &.select-none {
    user-select: none;
  }
  &.disabled {
    ::v-deep a{
      cursor: auto;
      pointer-events: none;
      color: inherit;
    }
  }

  .emoji {
    font-size: 20px;
    vertical-align: -2px;
  }

  &.pc{
    font-family: "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }
  &.pc.pc-not-frame{
     max-width: 460px;
  }
  /deep/
  .emojiText-image {
    height: 20px;
    vertical-align: top;
    min-width: 20px;
    max-width: 20px;
  }
}

// 处理c2b消息文字颜色
.msg-c2b{
  .msg-pure-text{
    color: #fff;
    ::v-deep a{
      color: #fff;
    }
  }
}

.msg-c2b-ref {
  opacity: .4;
  cursor: pointer;
  border-bottom: 1px solid rgba(255,255,255,.4);
  margin-bottom: 4px;
  padding-bottom: 4px;
  min-width: 130px;
  -webkit-tap-highlight-color: transparent;
  &.b2c {
      border-bottom: 1px solid #CDD0D9;
  }
  &-meta {
      display: flex;
      justify-content: space-between;
  }
  &-name {
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 10px;
  }
  &-content {
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      word-break: break-all;
  }
}
</style>
